import { TranslatedComponent, translation } from '@hh.ru/front-static-app';

import CurrencyType from 'src/constants/currency';

interface CurrencyPros {
    /** Префикс, добавляющийся перед выводом валюты*/
    prefix?: string;
    /** Валюта*/
    value: CurrencyType;
}

const TrlKeys = {
    AZN: 'AZN',
    BYR: 'BYR',
    EUR: 'EUR',
    KZT: 'KZT',
    RUR: 'RUR',
    UAH: 'UAH',
    USD: 'USD',
    UZS: 'UZS',
    GEL: 'GEL',
    KGS: 'KGS',
};

const Currency: TranslatedComponent<CurrencyPros> = ({ trls, prefix, value }) => {
    return (
        <>
            {prefix || ''}
            {trls[TrlKeys[value]]}
        </>
    );
};

export default translation(Currency);
